import {
	DC_TMPT_LIST,
	STR_TMPT_LIST,
	OMNI_TMPT_LIST,
	ECOM_INVENTORY,
	ECOM_SALES_LIST,
	MUMD_ORDER_LIST,
	FILTER_CONDITION_LABELS,
	REGISTER_SALES_LIST
} from 'constants/constant';

export const infoText =
	'You can apply up to 2 custom time ranges. Each custom time range is limited to 52 weeks.';

const yesterday = 'Yesterday';
const LastWeekend = 'Last Weekend [Fri-Sat-Sun]';
const weekToDate = 'WMT Week to date';
const monthToDate = 'WMT Month to date';
const yearToDate = 'WMT Year to date';
const wmtLastWeek = 'WMT Last week';
const wmtLastTwoWeeks = 'WMT Last 2 weeks';
const wmtLastFourWeeks = 'WMT Last 4 weeks';
const wmtLastThirteenWeeks = 'WMT Last 13 weeks';
const wmtLastTwentySixWeeks = 'WMT Last 26 weeks';
const wmtLastFiftyTwoWeeks = 'WMT Last 52 weeks';

const MTSWeekOptions = [
	{ label: FILTER_CONDITION_LABELS.WMT_LAST_WEEK, value: wmtLastWeek },
	{ label: FILTER_CONDITION_LABELS.WMT_LAST_2_WEEKS, value: wmtLastTwoWeeks },
	{ label: FILTER_CONDITION_LABELS.WMT_LAST_4_WEEKS, value: wmtLastFourWeeks },
	{ label: FILTER_CONDITION_LABELS.WMT_LAST_13_WEEKS, value: wmtLastThirteenWeeks },
	{ label: FILTER_CONDITION_LABELS.WMT_LAST_26_WEEKS, value: wmtLastTwentySixWeeks },
	{ label: FILTER_CONDITION_LABELS.WMT_LAST_52_WEEKS, value: wmtLastFiftyTwoWeeks }
];

export const MTS_MENU = {
	DAY: 'Day',
	WEEK: 'Week',
	FUZZY_TIME: 'Fuzzy time',
	CUSTOM: 'Custom'
};

const MTS_MENU_OPTIONS = {
	SSI: {
		[MTS_MENU.DAY]: [
			{ label: FILTER_CONDITION_LABELS.YESTERDAY, value: yesterday },
			{ label: FILTER_CONDITION_LABELS.WEEKEND, value: LastWeekend }
		],
		[MTS_MENU.WEEK]: MTSWeekOptions,
		[MTS_MENU.FUZZY_TIME]: [
			{ label: FILTER_CONDITION_LABELS.WMT_WEEK_TO_DATE, value: weekToDate },
			{ label: FILTER_CONDITION_LABELS.WMT_MONTH_TO_DATE, value: monthToDate },
			{ label: FILTER_CONDITION_LABELS.WMT_YEAR_TO_DATE, value: yearToDate }
		]
	},
	OMNI_SALES: {
		[MTS_MENU.DAY]: [
			{ label: FILTER_CONDITION_LABELS.YESTERDAY, value: yesterday },
			{ label: FILTER_CONDITION_LABELS.WEEKEND, value: LastWeekend }
		],
		[MTS_MENU.WEEK]: MTSWeekOptions,
		[MTS_MENU.FUZZY_TIME]: [
			{ label: FILTER_CONDITION_LABELS.WMT_WEEK_TO_DATE, value: weekToDate },
			{ label: FILTER_CONDITION_LABELS.WMT_YEAR_TO_DATE, value: yearToDate }
		]
	},
	DC_METRICS: {
		[MTS_MENU.DAY]: [
			{ label: FILTER_CONDITION_LABELS.YESTERDAY, value: yesterday },
			{ label: FILTER_CONDITION_LABELS.WEEKEND, value: LastWeekend }
		],
		[MTS_MENU.WEEK]: MTSWeekOptions,
		[MTS_MENU.FUZZY_TIME]: [
			{ label: FILTER_CONDITION_LABELS.WMT_WEEK_TO_DATE, value: weekToDate },
			{ label: FILTER_CONDITION_LABELS.WMT_YEAR_TO_DATE, value: yearToDate }
		]
	},
	ECOM_INVENTORY: {
		[MTS_MENU.DAY]: [{ label: FILTER_CONDITION_LABELS.YESTERDAY, value: yesterday }],
		[MTS_MENU.WEEK]: MTSWeekOptions,
		[MTS_MENU.FUZZY_TIME]: [
			{ label: FILTER_CONDITION_LABELS.WMT_WEEK_TO_DATE, value: weekToDate },
			{ label: FILTER_CONDITION_LABELS.WMT_YEAR_TO_DATE, value: yearToDate }
		]
	},
	ECOM_SALES: {
		[MTS_MENU.DAY]: [
			{ label: FILTER_CONDITION_LABELS.YESTERDAY, value: yesterday },
			{ label: FILTER_CONDITION_LABELS.WEEKEND, value: LastWeekend }
		],
		[MTS_MENU.WEEK]: MTSWeekOptions,
		[MTS_MENU.FUZZY_TIME]: [
			{ label: FILTER_CONDITION_LABELS.WMT_WEEK_TO_DATE, value: weekToDate },
			{ label: FILTER_CONDITION_LABELS.WMT_YEAR_TO_DATE, value: yearToDate }
		]
	},
	STORE_MARKUP_MARKDOWN: {
		[MTS_MENU.DAY]: [{ label: FILTER_CONDITION_LABELS.YESTERDAY, value: yesterday }],
		[MTS_MENU.WEEK]: MTSWeekOptions,
		[MTS_MENU.FUZZY_TIME]: [
			{ label: FILTER_CONDITION_LABELS.WMT_WEEK_TO_DATE, value: weekToDate },
			{ label: FILTER_CONDITION_LABELS.WMT_YEAR_TO_DATE, value: yearToDate }
		]
	},
	REGISTER_SALES: {
		[MTS_MENU.DAY]: [
			{ label: FILTER_CONDITION_LABELS.YESTERDAY, value: yesterday },
			{ label: FILTER_CONDITION_LABELS.WEEKEND, value: LastWeekend }
		],
		[MTS_MENU.WEEK]: MTSWeekOptions,
		[MTS_MENU.FUZZY_TIME]: [
			{ label: FILTER_CONDITION_LABELS.WMT_WEEK_TO_DATE, value: weekToDate },
			{ label: FILTER_CONDITION_LABELS.WMT_MONTH_TO_DATE, value: monthToDate },
			{ label: FILTER_CONDITION_LABELS.WMT_YEAR_TO_DATE, value: yearToDate }
		]
	}
};

export const getMenuOptions = (templateId) => {
	if (STR_TMPT_LIST.includes(templateId)) {
		return MTS_MENU_OPTIONS.SSI;
	}
	if (OMNI_TMPT_LIST.includes(templateId)) {
		return MTS_MENU_OPTIONS.OMNI_SALES;
	}
	if (DC_TMPT_LIST.includes(templateId)) {
		return MTS_MENU_OPTIONS.DC_METRICS;
	}
	if (ECOM_INVENTORY.includes(templateId)) {
		return MTS_MENU_OPTIONS.ECOM_INVENTORY;
	}
	if (ECOM_SALES_LIST.includes(templateId)) {
		return MTS_MENU_OPTIONS.ECOM_SALES;
	}
	if (MUMD_ORDER_LIST.includes(templateId)) {
		return MTS_MENU_OPTIONS.STORE_MARKUP_MARKDOWN;
	}
	if (REGISTER_SALES_LIST.includes(templateId)) {
		return MTS_MENU_OPTIONS.REGISTER_SALES;
	}
	return [];
};

export const getFormattedDateInput = (d, w = '', isWkEnabled) => {
	if (!d) {
		return '';
	}
	if (isWkEnabled) {
		return `Week ${w} (${d.format('MM/DD/YYYY')})`;
	}
	return d.format('MM/DD/YYYY');
};
